import React, { useState } from 'react';
import { Banner, Button, Input, ModalBox, PriceString, useModalContext, } from '@fourthwall/components';
import { getPrice } from '@fourthwall/utils';
import { PaymentMethodRequiredModal } from '@modules/Dashboard/modules/PaymentMethods';
import * as S from './OrderRefundConfirmModal.styled';
import { useGetRefundEstimatedCostsQuery } from './queries/useGetRefundEstimatedCostsQuery';
export const OrderRefundConfirmModal = ({ orderId, amount, initialReason, error, onConfirm, }) => {
    const { open, close } = useModalContext();
    const [reason, setReason] = useState(initialReason || '');
    const { getRefundEstimatedCostsQuery } = useGetRefundEstimatedCostsQuery([
        orderId,
        {
            refundAmount: parseFloat(amount),
            refundCurrency: 'USD',
        },
    ]);
    const openPaymentMethodRequiredModal = () => {
        const chargeDetails = getRefundEstimatedCostsQuery.data?.chargeDetails;
        const fromBalance = getRefundEstimatedCostsQuery.data?.fromBalance;
        if (!fromBalance || chargeDetails?.type !== 'REQUIRED') {
            return;
        }
        const amountPrice = getPrice(parseFloat(amount));
        const balancePrice = getPrice(fromBalance.value);
        const remainingPrice = getPrice(chargeDetails.amount.value);
        const balanceSplitCopy = fromBalance.value > 0
            ? `${balancePrice} will be deducted from your account balance and the remaining ${remainingPrice} will be charged to your payment method. `
            : '';
        open(PaymentMethodRequiredModal, {
            title: `Are you sure you want to refund ${amountPrice}?`,
            subtitle: (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    balanceSplitCopy,
                    "Refunds are sent directly to the supporter's original payment method."),
                React.createElement("p", null,
                    React.createElement("b", null,
                        "Payment method to cover ",
                        remainingPrice)))),
            submitLabel: `Refund ${amountPrice}`,
            onSuccess: () => {
                onConfirm({
                    fromBalance,
                    charge: chargeDetails.amount,
                }, reason.length ? reason : undefined);
            },
        });
    };
    const handleConfirm = () => {
        const estimatedCosts = getRefundEstimatedCostsQuery.data;
        if (!estimatedCosts) {
            return;
        }
        close();
        if (estimatedCosts.chargeDetails.type === 'REQUIRED') {
            openPaymentMethodRequiredModal();
            return;
        }
        onConfirm({
            fromBalance: estimatedCosts.fromBalance,
            charge: { value: 0, currency: 'USD' },
        }, reason.length ? reason : undefined);
    };
    return (React.createElement(ModalBox, { title: React.createElement(React.Fragment, null,
            "Are you sure you want to refund ",
            React.createElement(PriceString, { value: amount }),
            "?"), buttons: [
            React.createElement(Button, { label: "Back", appearance: "secondary", onClick: close }),
            React.createElement(Button, { label: `Yes, refund ${getPrice(parseFloat(amount))}`, appearance: "destructive", loading: getRefundEstimatedCostsQuery.isFetching, onClick: handleConfirm }),
        ], onClose: close },
        error && (React.createElement(S.ErrorBannerContainer, null,
            React.createElement(Banner, { appearance: "danger" }, error))),
        React.createElement(S.Info, null, "This cannot be undone. The cost of refunding will be taken from your account. Refunds will be sent directly to the supporter's payment method (it may take up to 48 hours to process)."),
        React.createElement(Input, { label: "Refund reason (optional)", suggestion: "Only you and other staff can see it.", value: reason, onValueChange: setReason })));
};
